import { useTranslation } from "@opendash/i18n";
import { Dropdown, Flex, Tag, Tooltip, Typography } from "antd";
import { ItemType } from "antd/es/menu/interface";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { Kanban_State } from "../../../../../../js/parsegenerated";
import { StateCircleIcon } from "../../../../state/components/StateCircleIcon";

type Props = {
  value?: Number | string;
  onChange?: (value: Number | string) => void;
  states: Kanban_State[];
};

export const StateInputDropdown = observer((props: Props) => {
  const t = useTranslation();
  const menuItems: ItemType[] = useMemo(
    () =>
      props.states?.map(
        (state) =>
          ({
            key: state.id,
            label: (
              <Flex gap="small" align="center">
                <StateCircleIcon color={state.get("color")} />
                <Typography.Text>{state.get("label")}</Typography.Text>
              </Flex>
            ),
          }) as ItemType
      ) ?? [],
    [props.states]
  );

  const stateValue = props.value
    ? props.states?.find((state) => state.id === props.value)
    : props.states?.find((state) => state.get("isInbox"));

  return (
    <Dropdown
      trigger={["click"]}
      menu={{
        items: menuItems,
        selectable: true,
        selectedKeys: [stateValue?.id],
        onSelect: (info) => props.onChange?.(info.key),
      }}
    >
      <Tooltip title={t("maintenance:ticket.creation.state.tooltip")}>
        <Tag style={{ cursor: "pointer" }}>
          <Flex align="center" gap="small">
            <StateCircleIcon color={stateValue?.get("color")} />
            <Typography.Text>{stateValue?.get("label")}</Typography.Text>
          </Flex>
        </Tag>
      </Tooltip>
    </Dropdown>
  );
});
